import { Fragment, useContext, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import AuthContext from "../../AuthContext";
import "react-country-state-city/dist/react-country-state-city.css";
import axiosInstance from "../../axios";
import { toast } from 'react-toastify';
import UserTypeDropdown from "../Dropdowns/UserTypesDropdown";

export default function AddProduct({
  addProductModalSetting,
  handlePageUpdate,
}) {
  const authContext = useContext(AuthContext);
  const [password, setPassword] = useState('');
  const [userType, setUserType] = useState('');
  const [user, setUser] = useState({
    full_name: '',
    email: '',
    phone_no: '',
    username: '',
  });
  const [open, setOpen] = useState(true);
  const [usernameError, setUsernameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const[validate,setValidate]=useState(false)
  const cancelButtonRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const validateForm = () => {
    const errors = {};

    if (!user.full_name.trim()) errors.full_name = 'Full Name is required';
  	if (!user.email.trim()) {
			errors.email = 'Email is required';
		} else if (!/\S+@\S+\.\S+/.test(user.email)) {
			errors.email = 'Email is invalid';
		}
    if (!user.phone_no) errors.phone_no = 'Contact No. is required';
    if (!user.username.trim()) errors.username = 'Username is required';
    if (!password) errors.password = 'Password is required';
    else if (password.length < 6) errors.password = 'Password must be at least 6 characters long';
    setFormErrors(errors);
    return Object.keys(errors).length === 0

  };
const imp=true
  const addTrainer = async () => {
    if (!validateForm()) return;

    try {
      const result = await axiosInstance.post('users/insertUser', {
        user_id: authContext.user,
        full_name: user.full_name,
        email: user.email,
        phone_no: user.phone_no,
        username: user.username,
        password: password,
        user_type: userType
      });
      setUsernameError(null)
      toast.success("User Added");
      handlePageUpdate();
      addProductModalSetting();
    } 
    catch (error) {
      // Extract and display error message from backend
      if (error.response && error.response.data && error.response.data.message) {
        setUsernameError(error.response.data.message)
      }
      
      else {
        
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-2 sm:w-full sm:max-w-lg">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div>
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900"
                      >
                        User
                      </Dialog.Title>

                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-2">
                          <div>
                            <label htmlFor="full_name" className="block mb-2 text-sm font-medium text-gray-800">
                              Full Name <span className='text-red-700'>*</span> 
                            </label>
                            <input
                              type='text'
                              className={`bg-gray-50 border ${formErrors.full_name ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5`}
                              id="full_name"
                              name="full_name"
                              value={user.full_name}
                              onChange={handleInputChange}
                            />
                            {formErrors.full_name && (
                              <p className="text-red-600 text-sm mt-2">{formErrors.full_name}</p>
                            )}
                          </div>
                          <div>
                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-800">
                              Email <span className='text-red-700'>*</span> 
                            </label>
                            <input
                              type='email'
                              className={`bg-gray-50 border ${formErrors.email ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5`}
                              id="email"
                              name="email"
                              value={user.email}
                              onChange={handleInputChange}
                            />
                            {formErrors.email && (
                              <p className="text-red-600 text-sm mt-2">{formErrors.email}</p>
                            )}
                          </div>
                          <div>
                            <label htmlFor="phone_no" className="block mb-2 text-sm font-medium text-gray-800">
                              Contact No. <span className='text-red-700'>*</span> 
                            </label>
                            <input
                              type='text'
                              maxLength={10}
                              className={`bg-gray-50 border ${formErrors.phone_no ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5`}
                              id="phone_no"
                              name="phone_no"
                              value={user.phone_no}
                              onChange={handleInputChange}
                            />
                            {formErrors.phone_no && (
                              <p className="text-red-600 text-sm mt-2">{formErrors.phone_no}</p>
                            )}
                          </div>
                          <div>
                            <label htmlFor="username" className="block mb-2 text-sm font-medium text-gray-800">
                              Username <span className='text-red-700'>*</span> 
                            </label>
                            <input
                              type='text'
                              className={`bg-gray-50 border ${usernameError || formErrors.username ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5`}
                              id="username"
                              name="username"
                              value={user.username}
                              onChange={handleInputChange}
                            />
                            {usernameError && (
                              <p className="text-red-600 text-sm mt-2">{usernameError}</p>
                            )}
                            {formErrors.username && (
                              <p className="text-red-600 text-sm mt-2">{formErrors.username}</p>
                            )}
                          </div>
                          <div>
                            <label htmlFor="password" className="block mb-2 text-sm font-medium">
                              Password <span className='text-red-700'>*</span> 
                            </label>
                            <input
                              type='password'
                              className={`bg-gray-50 border ${formErrors.password ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5`}
                              id="password"
                              name="password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                            {formErrors.password && (
                              <p className="text-red-600 text-sm mt-2">{formErrors.password}</p>
                            )}
                          </div>
                          <div>
                            <UserTypeDropdown handleInputChange={(e) => setUserType(e.target.value)} userType={userType} imp={imp} />
                          </div>
                        </div>
                        <div className="flex items-center space-x-4"></div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 text-right sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={addTrainer}
                  >
                    Add User
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center  ml-2 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => setOpen(false)}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
